var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-hk",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M164.8 0H909v744H165z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(.7 0 0 .7 -113.4 0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    d: "M1063 744.1H0V0h1063z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M516.4 360.1s-75-32.3-64.3-116c10.4-40.3 28.8-67.7 62.2-82.6a223 223 0 0 1 48-8.4c-4.4 4-8 8.1-9.8 13.2-3.6 9.2-1 18 3.8 26.8a78 78 0 0 1 10.8 34.4 53.2 53.2 0 0 1-21.2 49c-9.6 7.3-21 9.9-30.2 18.3a41.1 41.1 0 0 0-13.2 26.4c-.3 23.4 6.1 26.7 13.9 39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.1,
    d: "M502.1 239v-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 3.1,
    d: "M506.9 351.4c-29.2-25.8-26.7-90.7-4.4-112.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    d: "m501.9 223 9.6-2.1 1.1-9.4 4.8 8 9.6-2.1-6.6 7.1 4.8 8-9-3.6-6.6 7.1 1.2-9.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M522.8 354.6s8.9-81.2 92-95.4c41.6-1.9 73.2 7.7 97.3 35.2a223.4 223.4 0 0 1 22 43.4c-5.1-3-10-5.2-15.5-5.5-9.8-.7-17.4 4.4-24.4 11.5-8 8.8-17 15.3-29.8 20.4a53.3 53.3 0 0 1-53-5.9c-9.9-7-15.6-17.1-26.4-23.5a41 41 0 0 0-29.1-4.9c-22.5 6.7-23.7 13.7-33.2 24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.1,
    d: "m634.4 305.5.3-.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 3.1,
    d: "M528.3 343c16.1-35.5 79-52 106.2-37.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    d: "m649.6 300.6 4.8 8.6 9.3-1.7-6.2 7 4.9 8.5-8.8-4.3-6.3 7 .9-9.6-8.8-4.3 9.3-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M528.4 360.5s79.8-17.4 119.7 57c15 38.8 16 71.8-2.5 103.4-10 13-21.7 24-34.2 34.6 1.2-5.8 1.7-11.2.3-16.4-2.4-9.5-9.7-15.1-18.7-19.5a77.2 77.2 0 0 1-28.7-21.7 53.3 53.3 0 0 1-11.3-52.2c3.5-11.6 11.3-20.3 13.9-32.5a41 41 0 0 0-4.6-29.2c-13.4-19.1-20.5-18-34-23.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.1,
    d: "m610.4 450.7.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 3.1,
    d: "M541.1 362c38.8 4 74.5 58.4 69 88.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    d: "m619.8 463.6-6.5 7.3 4.5 8.3-8.6-3.8-6.5 7.4 1.3-9.7-8.6-3.7 9.3-2.2 1.3-9.7 4.5 8.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M526.6 368.7s39 71.7-21.1 131c-33.1 25.2-64.5 35.4-100 26.5-15.3-5.8-29.1-14-42.8-23 5.8-.5 11.2-1.5 15.8-4.4 8.4-5 11.8-13.5 13.5-23.4a77.2 77.2 0 0 1 12.7-33.7 53.2 53.2 0 0 1 47-25.4c12 .1 22.6 5.1 35 4.2a41 41 0 0 0 26.8-12.6c14.6-18.3 11.6-24.8 13-39.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.1,
    d: "m463 472.7-.2.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 3.1,
    d: "M528.7 381.4c7 38.3-35.1 87.8-66 91.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    d: "m453.3 485.4-8.9-4.2-6.7 6.7 1.2-9.3-8.9-4.2 9.7-1.5 1.1-9.3 4.8 8.4 9.6-1.5-6.7 6.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M517.7 367.1s-54.7 60.7-130.5 23.6c-34.8-22.8-54.9-49-58.3-85.4.4-16.3 3.6-32.1 7.5-48 2.5 5.3 5.1 10 9.4 13.4 7.5 6.3 16.7 6.7 26.5 5a77.2 77.2 0 0 1 36 .8 53.3 53.3 0 0 1 39.6 35.8c4 11.5 2.7 23 7.7 34.5a41 41 0 0 0 20.8 21c22 7.7 27.2 2.8 41.3-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 3.1,
    d: "M398.4 341.7h-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ba0000",
    strokeWidth: 3.1,
    d: "M506.4 373.4c-33.8 19.3-94.5-4-107.8-32"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ba0000",
    fillRule: "evenodd",
    d: "m383.2 336.8 1-9.8-8.4-4 9.1-2 1-9.8 4.7 8.6 9-2-6.2 7.3 4.6 8.6-8.5-4.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHk);
export default __webpack_public_path__ + "static/media/hk.71865b9002175c534148cb9164a1d3db.svg";
export { ForwardRef as ReactComponent };